import jump from 'jump.js'

// @link https://reactgo.com/css-snow-animation/

const flake = document.querySelector('.flake')
const container = document.querySelector('.flake__wrapper')

function createFlake() {
	// cloning the flake node
	const clone = flake.cloneNode(true)

	// creating left padding
	clone.style.paddingLeft = Math.random() * 20 + 'px'

	// animation duration between 3-5
	clone.style.animationDuration = Math.random() * 15 + 45 + 's'
	clone.style.opacity = Math.random() * 1
	container.append(clone) // adding clone flake to container
}

// to create more flakes decrease 100
const s = setInterval(createFlake, 30)

setTimeout(() => {
	clearInterval(s)
}, 5500) // flake creation stops after 3000 milliseconds or 3s

$('.button__page-down').on('click', function (event) {
	event.preventDefault()

	jump('#ways_you_can_share', {
		offset: -100,
	})
})
